// The ONE shape every modal takes, so a phone gets a sheet and a desk gets a centred card.
//
// The dialogs were `w-full max-w-lg`, centred, with no side margin and only the BODY capped
// (ConfirmDialog at 320px): about eight multi-field forms lived inside that 320px box, and on a
// phone the keyboard covered the submit button because the whole card was centred on a viewport
// the keyboard had just shrunk. As a bottom sheet capped at the dynamic viewport, with the body as
// the only scrolling part and the actions pinned at the foot, the submit is always on screen.
export const dialogOverlayClass = "fixed inset-0 z-40 bg-black/50";

export const dialogContentClass = [
  // Phone: a sheet rising from the bottom, full width, never taller than what is visible.
  "fixed inset-x-0 bottom-0 z-50 flex max-h-[92dvh] flex-col rounded-t-2xl border border-line bg-surface",
  "pb-[env(safe-area-inset-bottom)] shadow-[0_-12px_40px_-12px_rgba(0,0,0,.45)] outline-none",
  // From `sm:` up: a centred card with a margin on every side.
  "sm:inset-x-auto sm:bottom-auto sm:top-1/2 sm:left-1/2 sm:w-[calc(100%-2rem)] sm:max-w-lg",
  "sm:-translate-x-1/2 sm:-translate-y-1/2 sm:max-h-[85dvh] sm:rounded-panel sm:pb-0",
  "sm:shadow-[0_24px_70px_-18px_rgba(0,0,0,.6)]",
].join(" ");

/** The scrolling middle. Header and footer stay put around it. */
export const dialogBodyClass = "min-h-0 flex-1 overflow-y-auto overscroll-contain";
